import type { Cookies as CookiesType } from "@packages/framework";
import Cookies from "js-cookie";

import type { CookieKey } from "../types/cookieKey.types";

export type DeleteCookieProps = {
  cookies?: CookiesType;
  key: CookieKey;
};

export const deleteCookie = ({ cookies, key }: DeleteCookieProps) =>
  cookies ? cookies.delete(key) : Cookies.remove(key);
